import checkBrowser from './check-browser.js';

export default checkBrowser;
